import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const LegacyFileRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const { hash } = window.location;
    if (hash.startsWith('#/file/')) {
      const fileId = hash.split('/')[2];
      if (fileId) {
        navigate(`/file/${fileId}`, { replace: true });
      }
    }
  }, [navigate]);

  return null;
};

export default LegacyFileRedirect;
